<!-- Contenedor relativo: las coordenadas quedan sobre el mapa y no se salen del modal -->
<div class="installation-map">
  <div class="installation-coords">
    <input
      placeholder="{{ 'tables.latitude' | translate }}"
      class="form-control"
      type="number"
      [(ngModel)]="gatewayMarker.lat"
    />
    <input
      placeholder="{{ 'tables.longitude' | translate }}"
      class="form-control mt-2"
      type="number"
      [(ngModel)]="gatewayMarker.lng"
    />
  </div>

  <ng-container *ngIf="farmCoordinates && gatewayMarker">
    <div class="installation-map-canvas">
      <app-map-dynamic
        [ponds_coordinates]="farmCoordinates"
        [marker]="gatewayMarker"
        (clickFeederMap)="addMakerFarm($event)"
        (clickMapPolygon)="clickPolygonFarm($event)"
        (clickMap)="addMakerFarm($event)"
        [icon_marker]="'gateway'"
      >
      </app-map-dynamic>
    </div>
  </ng-container>
</div>
